import { createElement } from 'react';
const p = (props) => {
    const { content } = props;
    return createElement("p", null, content);
};
export default p;
